import React from 'react';

const options = [
  ['standard', 'Standard'],
  ['capacity', 'Capacity'],
  ['pickable', 'Pickable vs Reserve'],
  ['governance', 'Governance status'],
  ['drift', 'ShipHero drift'],
  ['replenishment', 'Replenishment'],
];

const ViewSelector = ({ value, onChange, hidden = [] }) => (
  <label className="inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-2.5 py-1.5 text-xs text-gray-600 shadow-sm">
    <span className="font-medium text-gray-400">View</span>
    <select
      aria-label="Warehouse view"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="border-0 bg-transparent py-0 pl-0 pr-6 text-xs font-medium text-gray-800 outline-none focus:ring-0"
    >
      {options.filter(([key]) => !hidden.includes(key)).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
    </select>
  </label>
);

export default ViewSelector;
